const dateTime = new Intl.DateTimeFormat("de-DE", { dateStyle: "medium", timeStyle: "short" });
const date = new Intl.DateTimeFormat("de-DE", { day: "2-digit", month: "2-digit", year: "numeric" });
const euro = new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" });

export function formatDateTime(iso: string): string {
  return dateTime.format(new Date(iso));
}

/** 2026-10-06T… → „06.10.2026“ */
export function formatDate(iso: string): string {
  return date.format(new Date(iso));
}

/** „3 von 9 verbunden“: Zahlen im deutschen Format (CLAUDE.md „Frontend“). */
export function formatCount(value: number): string {
  return value.toLocaleString("de-DE");
}

/** 0.3 → „0,30 €“ */
export function formatEuro(value: number): string {
  return euro.format(value);
}

/** Kleine Beträge je Abfrage mit bis zu vier Nachkommastellen: 0,0334 € statt 0,03 €. */
export function formatEuroFine(value: number): string {
  return `${value.toLocaleString("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 4 })} €`;
}
